import { ADD_NOTIFICATION_TYPE, ADD_NOTIFICATION_TYPE_ERROR, ADD_NOTIFICATION_TYPE_SUCCESS, DELETE_NOTIFICATION, DELETE_NOTIFICATION_ERROR, DELETE_NOTIFICATION_SUCCESS, NOTIFICATION_MANAGEMENT_DETAILS, NOTIFICATION_MANAGEMENT_DETAILS_ERROR, NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS, NOTIFICATION_MANAGEMENT_LIST, NOTIFICATION_MANAGEMENT_LIST_ERROR, NOTIFICATION_MANAGEMENT_LIST_SUCCESS, NOTIFICATION_MANAGEMENT_UPDATE, NOTIFICATION_MANAGEMENT_UPDATE_ERROR, NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS} from './constants';



export default function NotificationManagementReducer(state, action) {


	let notifications = [];
    
	switch (action.type) {
	case NOTIFICATION_MANAGEMENT_LIST:
		return {...state, loading: true, error : false};
	case NOTIFICATION_MANAGEMENT_LIST_SUCCESS : 
		
        
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};                        
				data.id = item.id ? item.id : 0;
				data.name = item.name;
				data.enabled = item.enabled;
				data.apiEnabled = item.apiEnabled;
				data.whatsappEnabled = item.whatsappEnabled;
				data.telegramEnabled = item.telegramEnabled;
				data.smsEnabled = item.smsEnabled;
				data.pushNotificationEnabled = item.pushNotificationEnabled;
				return notifications.push(data);
			});       
			return { ...state, notifications:notifications ,  loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, notifications : [] , loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}
	case NOTIFICATION_MANAGEMENT_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case ADD_NOTIFICATION_TYPE:
		return {...state, loading : true, error : false };
	case ADD_NOTIFICATION_TYPE_SUCCESS:
		return {...state, false : true, error : false , };

	case ADD_NOTIFICATION_TYPE_ERROR:
		return {...state, loading : false, error : true };

	case NOTIFICATION_MANAGEMENT_DETAILS:
		return { ...state, pending: true };
			
	case NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS:
	
		return { ...state, pending: false, details:action.payload, error: false };
	case NOTIFICATION_MANAGEMENT_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case NOTIFICATION_MANAGEMENT_UPDATE:
		return { ...state, pending: false };
	case NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS:
		return { ...state, pending: false, error: false };
	case NOTIFICATION_MANAGEMENT_UPDATE_ERROR:
		return { ...state, pending: false, error: true }; 
	case DELETE_NOTIFICATION:
		return { ...state, pending: false };
		
	case DELETE_NOTIFICATION_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_NOTIFICATION_ERROR:
		return { ...state, pending: false, error: true };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}